(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('AlumnoUadyMatriculadoDialogController', AlumnoUadyMatriculadoDialogController);

    AlumnoUadyMatriculadoDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'AlumnoUadyMatriculado'];

    function AlumnoUadyMatriculadoDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, AlumnoUadyMatriculado) {
        var vm = this;

        vm.alumnoUadyMatriculado = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.alumnoUadyMatriculado.id !== null) {
                AlumnoUadyMatriculado.update(vm.alumnoUadyMatriculado, onSaveSuccess, onSaveError);
            } else {
                AlumnoUadyMatriculado.save(vm.alumnoUadyMatriculado, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('serviciosocialApp:alumnoUadyMatriculadoUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
